<template>
  <q-layout view="hHh lpR fFf">

    <Shared/>
    <Header/>

    <q-page-container>
      <router-view name="top"/>
      <div class="row">
        <div class="col-24" :class="{ 'col-lg-18': !layoutContentWide }">
          <div class="container nopad-lt-lg">
            <div ref="mainColRef" style="position: relative;">
              <ClientOnlyRouterView
                  :keep-alive="true"
                  :include="routerStore.cachedComponents"
                  :max="5"
              />
              <q-resize-observer @resize="onMainColumnResize($event, mainColRef)"/>
            </div>
          </div>
        </div>
        <div
            class="col-24 col-lg-6 gt-md"
            v-if="!layoutContentWide"
        >
          <q-no-ssr v-if="$q.screen.gt.md">
            <VOrder/>
          </q-no-ssr>
        </div>
      </div>
    </q-page-container>

    <Footer class="gt-md q-mt-md"/>

  </q-layout>
</template>

<script setup lang="ts">
import Shared from "./ui/Shared.vue";
import VOrder from "@/components/Shop/VOrder/VOrder.vue";
import ClientOnlyRouterView from "@/core/components/ClientOnlyRouterView.vue";
import {useRouterStore} from "@/core/router/store";
import {useLayoutStore} from "@/stores/layout";
import {storeToRefs} from "pinia";
import {QNoSsr, useQuasar} from "quasar";
import {computed, ref} from "vue";
import Header from "@/layouts/ui/Header.vue";
import Footer from "./ui/Footer.vue";

const $q = useQuasar();

const layoutStore = useLayoutStore();
const {onMainColumnResize} = layoutStore

const routerStore = useRouterStore();
const {routeMeta} = storeToRefs(routerStore);
const layoutContentWide = computed(() => routeMeta.value.layoutContentWide);

const mainColRef = ref<HTMLElement | null>(null);

</script>
<style scoped lang="scss">

</style>
